import React from 'react';
import b_ from 'b_';

import i18n from 'assets/i18n/poll';

import {Icon} from 'client/common/components/lego';
import {StatusCode} from 'client/poll-landing/types';

import './status-message.css';

const b = b_.with('status-message');

const StatusMessage = ({code}: {code: StatusCode}) => {
    let message = '';

    switch (code) {
        case 'surveyAlreadyFinished':
            message = i18n.errors.survey.alreadyFinished;
            break;
        case 'surveyClosed':
            message = i18n.errors.survey.closed;
            break;
        case 'surveyNotFound':
            message = i18n.errors.survey.notFound;
            break;
        case 'surveyPaused':
            message = i18n.errors.survey.paused;
            break;
        case 'serverDefault':
            message = i18n.errors.server.default;
            break;
        case 'thanks':
            message = i18n.info.survey.thanks;
            break;
        default:
            break;
    }

    return message ? (
        <div className={b()}>
            <Icon className={b('icon')} type='info' size='l' />
            <div className={b('text')}>{message}</div>
        </div>
    ) : null;
};

export default StatusMessage;
